const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/ReportPage/ReportPage.tsx';
import { RouteComponentProps } from 'react-router';
import { useReports } from 'App/store/documents';
import textMap from 'App/pages/ReportPage/translations';
import * as React from 'react';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { sortObjectsByPath } from '@cistec/common_web/utils/data';
import { ReportList } from './ReportList';
import LoadingSpinner from '@cistec/common_web/components/LoadingSpinner';
import { EmptyState } from 'App/components/EmptyState/EmptyState';
import { IconClass } from '@cistec/common_web/defs/icons';
import { Page } from '../Page';
import _ from 'lodash';

export const ReportPage = (props: RouteComponentProps) => {
    const { data: reports, isPendingOrLoading: isLoadingReports } = useReports();
    const { formatMessage } = useIntl();

    const sortedReports = useMemo(() => {
        if (reports) {
            return _.clone(reports).sort(sortObjectsByPath(['DAT', 'NAME'], [true, false]));
        }
        return undefined;
    }, [reports]);

    const renderContent = () => {
        if (isLoadingReports) {
            return <LoadingSpinner center="absolute" delay={300} />;
        }
        if (sortedReports?.length) {
            return <ReportList reports={sortedReports} />;
        }
        return (
            <div>
                <EmptyState intlText={textMap.noReports} />
            </div>
        );
    };

    return (
        <Page title={formatMessage(textMap.cardTitle)} iconClass={IconClass.Document}>
            {renderContent()}
        </Page>
    );
};
